var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-link',{staticClass:"d-block w-100 text-center",attrs:{"to":_vm.AuthRepo.get_default_location()}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logo_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }